// Hook odpowiedzialny za pobranie karty produktu w formacie PDF (base64).
// Zwraca content (base64) + file_name. Akcja, NIE cache'owany zasób - useMutation.

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

// typ zwracanych danych
export interface IResponse {
  content: string;
  file_name: string;
}

const getProductExport = (id: number): Promise<IResponse> =>
  axios.get(`/products/${id}/export`);

export const useGetProductExport = (
  options?: UseMutationOptions<IResponse, IError, number>
) => useMutation<IResponse, IError, number>(getProductExport, options);
